<template>
  <div>
    <div class="table-page-search-wrapper" style="margin-left: 200px">
      <a-spin :spinning="loading">
        <a-form :form="form" >
          <a-row :gutter="[16,16]">
            <a-col :span="12">
              <a-form-item label="编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input
                  disabled
                  v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]"
                  placeholder="请输入"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="面积" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input-number
                  v-decorator="['area', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                  placeholder="请输入"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="false">
              <a-form-item label="是否已出租" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-switch
                  v-decorator="['is_rented', {initialValue: false, valuePropName: 'checked'}]"
                  placeholder="请选择"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :offset="6" span="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import pick from 'lodash.pick'
import { zone_property_cell_chops_update } from '@/api/zone_property_cell'
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      loading: false,
      form: this.$form.createForm(this),
      id: 0,
      actionUrl: '',
      previewVisible: false,
      previewImage: '',
      new_multipart_params: {
        'key': '',
        'policy': '',
        'OSSAccessKeyId': '',
        'success_action_status': '200',
        'signature': ''
      },
      fileList: [],
      filePathList: [],
      filePathUrls: ''
    }
  },
  // beforeCreate () {
  //   this.form = this.$form.createForm(this)
  // },
  mounted () {
    this.$nextTick(() => {
      this.loadEditInfo(this.record)
    })
  },
  methods: {
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (!err) {
          this.loading = true
          zone_property_cell_chops_update(values, this.id)
            .then((res) => {
              if (res.code === 1000) {
                this.handleGoBack()
              }
            }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, ['number', 'area', 'is_rented'])
        this.id = data.id
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
